export type AdminSettingsDestination = "users" | "integrations";

const ADMIN_SETTINGS_DESTINATIONS: Record<AdminSettingsDestination, string> = {
  users: "/members",
  integrations: "/integrations",
};

export const buildAdminSettingsPath = (
  destination: AdminSettingsDestination,
): string => ADMIN_SETTINGS_DESTINATIONS[destination];
